"use strict";
!(function() {
  var e, t, s, i, n, o = document.getElementsByTagName("html")[0];
  if (o.className = o.className.replace(/\bno-js\b/, "") + "js", "ontouchstart" in window || navigator.maxTouchPoints ? o.className = o.className + " touch" : o.className = o.className + " no-touch", e = 8, n = "lte", t = "IE", s = document.createElement("B"), i = document.documentElement, e && (t = t + " " + e, n) && (t = n + " " + t), s.innerHTML = "<!--[if " + t + ']><b id="iecctest"></b><![endif]-->', i.appendChild(s), e = Boolean(document.getElementById("iecctest")), i.removeChild(s), o.className = e ? o.className + " ie8" : o.className + " no-ie8", (-1 < (n = navigator.userAgent.toLowerCase()).indexOf("webkit") || -1 < n.indexOf("opera") || -1 < n.indexOf("msie")) && document.getElementById && window.addEventListener && window.addEventListener("hashchange", function() {
    var e2 = document.getElementById(location.hash.substring(1));
    e2 && (/^(?:a|select|input|button|textarea)$/i.test(e2.nodeName) || (e2.tabIndex = -1), e2.focus());
  }, false), "undefined" == typeof jQuery) throw new Error("JavaScript de Portal Unificado requiere jQuery.");
  $.fn.toggleAttr = function(t2, s2, i2) {
    return this.each(function() {
      var e2 = $(this);
      e2.attr(t2) == s2 ? e2.attr(t2, i2) : e2.attr(t2, s2);
    });
  }, $.fn.accessibleMenu = function() {
    var e2 = $(this), t2 = "Nav-item", s2 = "hover";
    $(".Nav-item", e2).mouseover(function() {
      $(this).addClass(s2);
    }).mouseout(function() {
      $(this).removeClass(s2);
    }), $("a", e2).focus(function() {
      $(this).parents("." + t2).addClass(s2);
    }).blur(function() {
      $(this).parents("." + t2).removeClass(s2);
    });
  }, jQuery().accessibleMenu && $(".Nav .Container") && $(".Nav .Container").accessibleMenu(), $(".Nav-item") && $(".Nav-item").click(function() {
    $(this).toggleClass("hover");
  }), $(".Event-map") && $(".Event-map").click(function() {
    $(this).addClass("is-visible");
  }), $(".js-print").click(function() {
    window.print();
  });
  var a = $("body"), l = $(window).width();
  function r() {
    a.removeClass("has-parentNavAside"), $(".ParentNav-aside").empty(), $(".ParentNav-item.has-submenu").removeClass("is-open");
  }
  $(window).resize(function() {
    (l = $(window).width()) < 992 && $(".js-toggleLocalNav").click(function(e2) {
      e2.preventDefault(), $(this).parent(".Page-nav").toggleClass("is-open");
    });
  }), l < 992 && $(".js-toggleLocalNav").click(function(e2) {
    e2.preventDefault(), $(this).parent(".Page-nav").toggleClass("is-open");
  }), $(".js-menuTrigger").on("click", function() {
    $(".js-mainNav").toggleClass("is-open"), a.toggleClass("has-menu");
  }), $(".js-parentMenuTrigger").on("click", function() {
    $(window).scrollTop(0), $(".js-parentNav").toggleClass("is-open"), $(".js-parentNav").find(".js-menuClose").focus(), a.toggleClass("has-menu");
  }), $(document).on("click", function(e2) {
    if ($(e2.target).closest(".main-bar").length || $(e2.target).closest("[data-component='dropdown']").length || $(e2.target).closest("[data-dropdown-menu]").length || $(e2.target).closest("#dropdown-menu-account").length || $(e2.target).closest(".main-bar__dropdown-trigger").length) {
      return;
    }
    $(".js-parentNav").removeClass("is-open"), $("body").removeClass("has-menu");
  }), $(".js-parentMenuTrigger, .js-parentNav, .js-menuClose").on("click", function(e2) {
    var t2 = $(e2.target);
    if (t2.closest(".main-bar,[data-component='dropdown'],[data-dropdown-menu],#dropdown-menu-account,.main-bar__dropdown-trigger").length) {
      return;
    }
    e2.stopPropagation();
  }), $(".js-menuClose").on("click", function() {
    $(".js-parentNav").removeClass("is-open"), a.removeClass("has-menu"), a.removeClass("has-parentNavAside"), $(".Menu-aside").empty(), $(".Menu-item.has-submenu").removeClass("is-open");
  }), $(".ParentNav-item.has-submenu").on("keyup", function(e2) {
    13 == e2.keyCode && $(this).click();
  }), $(".ParentNav-item.has-submenu").on("click", function() {
    var e2;
    $(this).hasClass("is-open") ? 1180 < l ? r() : ($(".ParentNav-item.has-submenu").removeClass("is-open"), $(".ParentNav-subNav").removeClass("is-open")) : 1180 < l ? (r(), e2 = $(this).find(".ParentNav-subNav").html(), $(this).addClass("is-open"), a.addClass("has-parentNavAside"), $(".ParentNav-aside").html(e2).find("a")[0].focus()) : ($(".ParentNav-item.has-submenu").removeClass("is-open"), $(".ParentNav-subNav").removeClass("is-open"), $(this).find(".ParentNav-subNav").addClass("is-open"), $(this).addClass("is-open"));
  });
})(), (function() {
  var n, o = $(".js-pageIndex"), a = null;
  o.length && (n = false, o.hasClass("js-pageIndexMobile") && (n = true), $(".js-toggleIndex").on("click", function(e) {
    if (e.preventDefault(), !a) return false;
    a.toggleClass("is-open");
  }), o.find(".Index-body a").on("click", function(e) {
    o.removeClass("is-open");
    var t = $(this).attr("href");
    "#" === t[0] && (e.preventDefault(), t = t.replace("#", ""), e = document.getElementById(t)) && e.scrollIntoView({ block: "start", behavior: "smooth" });
  }), $(window).on("scroll", function() {
    var e, t = $(this).scrollTop(), s = o.innerHeight(), i = o.offset().top;
    n ? (e = $(".u-main")).length ? e.offset().top < t ? (a || (a = o.clone(true).appendTo("body")).addClass("is-clone"), a.addClass("is-visible"), a.addClass("is-fixed")) : a && (a.removeClass("is-open"), a.removeClass("is-fixed")) : console.error("No se encontr\xF3 .u-main") : i + s < t ? (a || (a = o.clone(true).appendTo("body")).addClass("is-clone"), a.addClass("is-visible"), a.addClass("is-fixed")) : a && (a.removeClass("is-open"), a.removeClass("is-fixed"));
  }));
})(), (function() {
  var s = "is-visible", t = "is-open", i = $(".js-menuBreadcrumb"), n = $("#js-breadcrumb-2"), o = $("#js-breadcrumb-3"), a = $(".Menu-root"), l = $(".Menu-page"), r = $(".Menu-subPage");
  $(".Menu-item.has-submenu > span").on("keyup", function(e) {
    13 == e.keyCode && ($(this).click(), $(this).siblings(".Menu-subNav").find("List-item:first-child").focus());
  }), $(".Menu-item.has-submenu > span").on("click", function() {
    $(this).hasClass(t) ? ($(this).removeClass(t), $(this).siblings(".Menu-subNav").animate({ height: "toggle" }, 250, function() {
      $(this).removeClass(t);
    })) : ($(".Menu-item.has-submenu > span").removeClass(t), a.find(".Menu-subNav").slideUp().removeClass(t), $(this).addClass(t), $(this).siblings(".Menu-subNav").animate({ height: "toggle" }, 250, function() {
      $(this).addClass(t).find(".List-item:first-child").focus();
    }));
  }), $(".Menu-root .List-item.has-submenu").on("keyup", function(e) {
    13 == e.keyCode && $(this).click();
  }), $(".Menu-root .List-item.has-submenu").on("click", function() {
    var e = $(this).attr("data-target");
    l.removeClass(s), r.removeClass(s), a.removeClass(s), n.addClass(s), i.addClass(s), $(e).addClass(s);
  }), $(".js-childItems").on("click", function() {
    var e = $(this).attr("data-target"), t2 = $(this).closest(".Menu-page").attr("data-title");
    a.removeClass(s), l.removeClass(s), r.removeClass(s), $(e).addClass(s), o.html('<a href="#">' + t2 + "</a>").addClass(s);
  }), $("#js-breadcrumb-1").on("click", function(e) {
    e.preventDefault(), n.removeClass(s), o.removeClass(s), i.removeClass(s), $(".js-organismosSubmenu > span").removeClass(t), $(".js-organismosSubmenu > .Menu-subNav").removeClass(t).hide(), l.removeClass(s), r.removeClass(s), a.addClass(s);
  }), n.on("click", function(e) {
    e.preventDefault();
    e = $(this).attr("data-target");
    $(e).addClass(s), $(".js-organismosSubmenu > span").addClass(t), $(".js-organismosSubmenu > .Menu-subNav").addClass(t), o.removeClass(s), $(this).removeClass(s), i.removeClass(s), r.removeClass(s), l.removeClass(s);
  }), o.on("click", function(e) {
    e.preventDefault();
    e = $(this).attr("data-target");
    $(this).removeClass(s), l.removeClass(s), r.removeClass(s), $(e).addClass(s);
  });
})(), (function() {
  var s = $(".js-scrollWrap"), i = $(".js-scrollNext"), n = $(".js-scrollPrev");
  n.hide(), i.on("click", function() {
    s.animate({ scrollLeft: s.scrollLeft() + s.width() / 1.75 }, 500);
  }), n.on("click", function() {
    s.animate({ scrollLeft: s.scrollLeft() - s.width() / 1.75 }, 500);
  }), s.on("scroll", function(e) {
    var t = $(this).scrollLeft();
    0 == t ? n.fadeOut(350) : n.fadeIn(350), t >= s[0].scrollWidth - s.innerWidth() ? i.fadeOut(350) : i.fadeIn(350);
  });
})(), (function() {
  var o = $(".js-tableTarget"), a = $(".js-tableCollapse");
  function e() {
    var e2 = a.find("thead tr th:first-child").innerWidth(), t = a.find("thead tr th:nth-child(2)").innerWidth(), s = a.find("thead tr th:nth-child(3)").innerWidth(), i = a.find("thead tr th:nth-child(4)").innerWidth(), n = a.find("thead tr th:nth-child(5)").innerWidth();
    o.find("tbody tr td:first-child").css("width", e2 - 8), o.find("tbody tr td:nth-child(2)").css("width", t - 8), o.find("tbody tr td:nth-child(3)").css("width", s - 8), o.find("tbody tr td:nth-child(4)").css("width", i - 8), o.find("tbody tr td:nth-child(5)").css("width", n - 8);
  }
  $(window).on("resize", e), e(), $('tr[data-toggle="collapse"]').on("click", function() {
    $(this).find(".js-collapseStatus").toggleClass("is-open"), "false" == $(this).attr("aria-expanded") ? $(this).attr("aria-expanded", "true") : $(this).attr("aria-expanded", "false");
  }), o.on("show.bs.collapse", function() {
    $(this).closest("table").find(".collapse.in").not(this).collapse("toggle");
  });
})(), $(".js-openChat").on("click", function(e) {
  e.preventDefault(), $(this).addClass("u-hide");
  e = $(".Asistente-contenedor");
  e.removeClass("u-hide"), e[0].offsetHeight, e.addClass("is-visible");
}), $(".js-closeChat").on("click", function(e) {
  e.preventDefault();
  const t = $(".Asistente-contenedor");
  t.removeClass("is-visible"), setTimeout(() => {
    t.addClass("u-hide");
  }, 350), $(".js-openChat").removeClass("u-hide");
}), document.addEventListener("DOMContentLoaded", () => {
  var e = document.querySelectorAll(".js-iniciarTramite");
  let d = null;
  e.forEach((n) => {
    const o = n.nextElementSibling;
    if (o) {
      const a = (e2) => {
        e2 && (e2.classList.remove("dropdown-outside"), e2.style.display = "none", n.parentElement.appendChild(e2), d = null, n.classList.remove("is-active"), document.removeEventListener("click", l), document.removeEventListener("keydown", r), n.focus());
      }, l = (e2) => {
        n.contains(e2.target) || o.contains(e2.target) || a(d);
      }, r = (e2) => {
        "Escape" === e2.key ? a(d) : "Tab" === e2.key && d && t(e2);
      }, t = (e2) => {
        var t2 = Array.from(o.querySelectorAll("a")), s = t2[0], t2 = t2[t2.length - 1];
        e2.shiftKey && document.activeElement === s ? (e2.preventDefault(), n.focus()) : !e2.shiftKey && document.activeElement === t2 && (e2.preventDefault(), a(d), s = n.closest(".ButtonCombo"), e2 = (t2 = Array.from(s.querySelectorAll("button,a,input,select,textarea,[tabindex]:not([tabindex='-1'])"))).indexOf(n), s = t2[e2 + 1]) && s.focus();
      };
      n.addEventListener("click", (t2) => {
        if (t2.stopPropagation(), o !== d) {
          d && d !== o && a(d), o.style.display = "block", o.classList.add("dropdown-outside"), document.body.appendChild(o);
          var t2 = n.getBoundingClientRect(), s = o.offsetWidth, i = window.innerWidth - t2.left;
          let e2;
          e2 = s <= i ? t2.left + window.scrollX : t2.right - s + window.scrollX;
          i = t2.bottom + window.scrollY, o.style.position = "absolute", o.style.top = i + "px", o.style.left = e2 + "px", o.style.zIndex = "9999", d = o, n.classList.add("is-active"), s = o.querySelector("li a");
          s && s.focus(), document.addEventListener("click", l), document.addEventListener("keydown", r);
        } else a(d);
      });
    }
  });
});
var $width = $(window).width(), $respwidth = 992;
$(function() {
  $(".js-navDropdown").each(function() {
    var e, i2 = $(this);
    i2.find("ul > li:has(.subnav)").find("a").addClass("w-sub"), i2.find(".NavToggle-item").attr("aria-expanded", "false"), i2.find(".NavToggle-item").click(function(e2) {
      var t2 = $(this).siblings(".subnav"), s2 = "true" === $(this).attr("aria-expanded");
      0 < t2.length && (e2.preventDefault(), i2.find(".subnav").not(t2).removeClass("show").removeClass("show-right"), i2.find(".NavToggle-item").not(this).removeClass("active").attr("aria-expanded", "false"), t2.toggleClass("show"), $(this).toggleClass("active"), $(this).attr("aria-expanded", !s2), t2.offset().left + t2.outerWidth() > $(window).width()) && t2.addClass("show-right");
    }), i2.on("keydown", function(e2) {
      var t2, s2;
      "Escape" === e2.key && (s2 = (t2 = i2.find(".subnav.show")).siblings(".NavToggle-item"), 0 < t2.length) && (e2.preventDefault(), t2.removeClass("show").removeClass("show-right"), s2.removeClass("active").attr("aria-expanded", "false"), s2.focus());
    }), $(document).click(function(e2) {
      if ($(e2.target).closest(i2).length) {
        return;
      }
      i2.find(".subnav").removeClass("show show-right");
      i2.find(".NavToggle-item").removeClass("active").attr("aria-expanded", "false");
    }), i2.mouseleave(function() {
      e = setTimeout(function() {
        i2.find(".subnav").removeClass("show").removeClass("show-right"), i2.find(".NavToggle-item").removeClass("active").attr("aria-expanded", "false");
      }, 250);
    }), i2.find(".NavToggle-item, .subnav").mouseenter(function() {
      clearTimeout(e);
    });
  });
  var t = $(".Nav--flex"), s = $(".NavSearch-wrapper"), i = (t.find(".subnav"), $(".js-navTrigger")), n = $(".Header-body"), o = $(".Header-top"), a = $(".js-searchTrigger"), l = $(".Header-search");
  $("#searchButtonWrap-md, #navButtonWrap-md").click(function(e) {
    e.preventDefault(), l.toggleClass("show"), $(".Header-right .searchButtonWrap-md").toggleClass("hide"), $(".Header-right nav ul").toggleClass("hide"), $("#menu").hasClass("hide") ? $("#menu a").attr("tabindex", "-1") : $("#menu a").removeAttr("tabindex"), l.hasClass("show") ? $(".Header-search input, .Header-search button").removeAttr("tabindex") : $(".Header-search input, .Header-search button").attr("tabindex", "-1"), $(this).is("#searchButtonWrap-md") && $("#search").focus(), $(this).is("#navButtonWrap-md") && $("#item-1").focus();
  }), $(document).on("keydown", function(e) {
    "Escape" !== e.key && 27 !== e.keyCode || l.hasClass("show") && 0 < $(".Header-search").has(document.activeElement).length && (l.removeClass("show"), $(".Header-right .searchButtonWrap-md").removeClass("hide"), $(".Header-right nav ul").removeClass("hide"), $("#menu a").removeAttr("tabindex"), $(".Header-search input, .Header-search button").attr("tabindex", "-1"), $("#searchButtonWrap-md button").focus());
  }), i.click(function(e) {
    e.preventDefault(), s.css("top", n.outerHeight() + o.outerHeight() + ($("#sticky-header-container").outerHeight() || 0) - 1), s.removeClass("openSearch"), t.toggleClass("is-open"), a.removeClass("show"), l.removeClass("show"), $(this).toggleClass("show"), s.toggleClass("openNav");
    e = document.querySelector("#menu a");
    e && e.focus(), $(".Header--catalogo").removeClass("Header--openSearch");
  }), a.click(function(e) {
    e.preventDefault(), s.css("top", n.outerHeight() + o.outerHeight() + ($("#sticky-header-container").outerHeight() || 0) - 1), s.removeClass("openNav"), t.removeClass("is-open"), i.removeClass("show"), $(this).toggleClass("show"), s.toggleClass("openSearch"), $("#search").focus(), $(".Header--catalogo").removeClass("Header--openSearch");
  }), 0 < $(".Header--catalogo").length && ($("#navButtonWrap-md").click(), $(window).width() < $respwidth) && (a.click(), $(".Header--catalogo").toggleClass("Header--openSearch")), $(".js-site-menu-trigger").click(function(e) {
    e.preventDefault(), $(".Nav-site").toggleClass("is-open"), $(".Parent").toggleClass("is-open"), $(this).toggleClass("is-open");
  });
}), $(document).ready(function() {
  const t = $(".gubuy-mega-menu"), s = $(".js-gubuyMegamenu"), i = ["#item-meg-1", "#item-meg-2", "#item-meg-3", "#item-meg-4", "#item-meg-5"];
  let e = t.parent();
  function n() {
    $(window).width() < 992 ? $(".Header-body").before(t) : e.append(t);
  }
  function o(e2, t2) {
    e2.removeClass("show"), t2.attr("aria-expanded", "false"), e2.find("a, button, input, [tabindex]").attr("tabindex", "-1"), t2.focus(), $(document).off("keydown.megamenu");
  }
  n(), $(window).resize(n), t.hasClass("show") || t.find("a, button, input, [tabindex]").attr("tabindex", "-1"), s.add(".close-mega-menu").click(function(e2) {
    e2.preventDefault(), t.hasClass("show") ? o(t, s) : (t.addClass("show"), s.attr("aria-expanded", "true"), t.find("a, button, input, [tabindex]").removeAttr("tabindex"), i.forEach((e3) => {
      t.find(e3).attr("tabindex", "-1");
    }), (e2 = t.find('a, button, input, [tabindex]:not([tabindex="-1"])').filter(":visible").first()).length && e2.focus(), $(document).on("keydown.megamenu", function(e3) {
      "Escape" === e3.key && o(t, s);
    }));
  }), $(document).on("focusin", function(e2) {
    !t.hasClass("show") && t.has(e2.target).length && (e2.preventDefault(), s.focus());
  });
}), (function(i) {
  "use strict";
  i.fn.emulateTransitionEnd = function(e) {
    var t = false, s = this;
    i(this).one("bsTransitionEnd", function() {
      t = true;
    });
    return setTimeout(function() {
      t || i(s).trigger(i.support.transition.end);
    }, e), this;
  }, i(function() {
    i.support.transition = (function() {
      var e, t = document.createElement("bootstrap"), s = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };
      for (e in s) if (t.style[e] !== void 0) return { end: s[e] };
      return false;
    })(), i.support.transition && (i.event.special.bsTransitionEnd = { bindType: i.support.transition.end, delegateType: i.support.transition.end, handle: function(e) {
      if (i(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
    } });
  });
})(jQuery), (function(n) {
  "use strict";
  var o = function(e2, t) {
    this.$element = n(e2), this.options = n.extend({}, o.DEFAULTS, t), this.$trigger = n('[data-toggle="collapse"][href="#' + e2.id + '"],[data-toggle="collapse"][data-target="#' + e2.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
  };
  function s(e2) {
    e2 = e2.attr("data-target") || (e2 = e2.attr("href")) && e2.replace(/.*(?=#[^\s]+$)/, "");
    return n(e2);
  }
  function a(i) {
    return this.each(function() {
      var e2 = n(this), t = e2.data("bs.collapse"), s2 = n.extend({}, o.DEFAULTS, e2.data(), "object" == typeof i && i);
      !t && s2.toggle && /show|hide/.test(i) && (s2.toggle = false), t || e2.data("bs.collapse", t = new o(this, s2)), "string" == typeof i && t[i]();
    });
  }
  o.VERSION = "3.3.7", o.TRANSITION_DURATION = 350, o.DEFAULTS = { toggle: true }, o.prototype.dimension = function() {
    return this.$element.hasClass("width") ? "width" : "height";
  }, o.prototype.show = function() {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var e2 = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
      if (!(e2 && e2.length && (i = e2.data("bs.collapse")) && i.transitioning)) {
        var t = n.Event("show.bs.collapse");
        if (this.$element.trigger(t), !t.isDefaultPrevented()) {
          e2 && e2.length && (a.call(e2, "hide"), i || e2.data("bs.collapse", null));
          var s2 = this.dimension(), t = (this.$element.removeClass("collapse").addClass("collapsing")[s2](0), this.$trigger.removeClass("collapsed"), this.transitioning = 1, function() {
            this.$element.removeClass("collapsing").addClass("collapse in")[s2](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
          });
          if (!n.support.transition) return t.call(this);
          var i = n.camelCase(["scroll", s2].join("-"));
          this.$element.one("bsTransitionEnd", n.proxy(t, this)).emulateTransitionEnd(o.TRANSITION_DURATION)[s2](this.$element[0][i]);
        }
      }
    }
  }, o.prototype.hide = function() {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var e2 = n.Event("hide.bs.collapse");
      if (this.$element.trigger(e2), !e2.isDefaultPrevented()) {
        var e2 = this.dimension(), t = (this.$element[e2](this.$element[e2]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in"), this.$trigger.addClass("collapsed"), this.transitioning = 1, function() {
          this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        });
        if (!n.support.transition) return t.call(this);
        this.$element[e2](0).one("bsTransitionEnd", n.proxy(t, this)).emulateTransitionEnd(o.TRANSITION_DURATION);
      }
    }
  }, o.prototype.toggle = function() {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  }, o.prototype.getParent = function() {
    return n(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(n.proxy(function(e2, t) {
      t = n(t);
      this.addAriaAndCollapsedClass(s(t), t);
    }, this)).end();
  }, o.prototype.addAriaAndCollapsedClass = function(e2, t) {
    e2 = e2.hasClass("in");
    t.toggleClass("collapsed", !e2);
  };
  var e = n.fn.collapse;
  n.fn.collapse = a, n.fn.collapse.Constructor = o, n.fn.collapse.noConflict = function() {
    return n.fn.collapse = e, this;
  }, n(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(e2) {
    var t = n(this), e2 = (t.attr("data-target") || e2.preventDefault(), s(t)), t = e2.data("bs.collapse") ? "toggle" : t.data();
    a.call(e2, t);
  });
})(jQuery), (function(o) {
  "use strict";
  var a = function(e2, t) {
    this.options = t, this.$body = o(document.body), this.$element = o(e2), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = false, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, o.proxy(function() {
      this.$element.trigger("loaded.bs.modal");
    }, this));
  };
  function n(i, n2) {
    return this.each(function() {
      var e2 = o(this), t = e2.data("bs.modal"), s = o.extend({}, a.DEFAULTS, e2.data(), "object" == typeof i && i);
      t || e2.data("bs.modal", t = new a(this, s)), "string" == typeof i ? t[i](n2) : s.show && t.show(n2);
    });
  }
  a.VERSION = "3.3.7", a.TRANSITION_DURATION = 300, a.BACKDROP_TRANSITION_DURATION = 150, a.DEFAULTS = { backdrop: true, keyboard: true, show: true }, a.prototype.toggle = function(e2) {
    return this.isShown ? this.hide() : this.show(e2);
  }, a.prototype.show = function(s) {
    var i = this, e2 = o.Event("show.bs.modal", { relatedTarget: s });
    this.$element.trigger(e2), this.isShown || e2.isDefaultPrevented() || (this.isShown = true, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', o.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
      i.$element.one("mouseup.dismiss.bs.modal", function(e3) {
        o(e3.target).is(i.$element) && (i.ignoreBackdropClick = true);
      });
    }), this.backdrop(function() {
      var e3 = o.support.transition && i.$element.hasClass("fade"), t = (i.$element.parent().length || i.$element.appendTo(i.$body), i.$element.show().scrollTop(0), i.adjustDialog(), e3 && i.$element[0].offsetWidth, i.$element.addClass("in"), i.enforceFocus(), o.Event("shown.bs.modal", { relatedTarget: s }));
      e3 ? i.$dialog.one("bsTransitionEnd", function() {
        i.$element.trigger("focus").trigger(t);
      }).emulateTransitionEnd(a.TRANSITION_DURATION) : i.$element.trigger("focus").trigger(t);
    }));
  }, a.prototype.hide = function(e2) {
    e2 && e2.preventDefault(), e2 = o.Event("hide.bs.modal"), this.$element.trigger(e2), this.isShown && !e2.isDefaultPrevented() && (this.isShown = false, this.escape(), this.resize(), o(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), o.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", o.proxy(this.hideModal, this)).emulateTransitionEnd(a.TRANSITION_DURATION) : this.hideModal());
  }, a.prototype.enforceFocus = function() {
    o(document).off("focusin.bs.modal").on("focusin.bs.modal", o.proxy(function(e2) {
      document === e2.target || this.$element[0] === e2.target || this.$element.has(e2.target).length || this.$element.trigger("focus");
    }, this));
  }, a.prototype.escape = function() {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", o.proxy(function(e2) {
      27 == e2.which && this.hide();
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
  }, a.prototype.resize = function() {
    this.isShown ? o(window).on("resize.bs.modal", o.proxy(this.handleUpdate, this)) : o(window).off("resize.bs.modal");
  }, a.prototype.hideModal = function() {
    var e2 = this;
    this.$element.hide(), this.backdrop(function() {
      e2.$body.removeClass("modal-open"), e2.resetAdjustments(), e2.resetScrollbar(), e2.$element.trigger("hidden.bs.modal");
    });
  }, a.prototype.removeBackdrop = function() {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
  }, a.prototype.backdrop = function(e2) {
    var t, s = this, i = this.$element.hasClass("fade") ? "fade" : "";
    this.isShown && this.options.backdrop ? (t = o.support.transition && i, this.$backdrop = o(document.createElement("div")).addClass("modal-backdrop " + i).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", o.proxy(function(e3) {
      this.ignoreBackdropClick ? this.ignoreBackdropClick = false : e3.target === e3.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide());
    }, this)), t && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), e2 && (t ? this.$backdrop.one("bsTransitionEnd", e2).emulateTransitionEnd(a.BACKDROP_TRANSITION_DURATION) : e2())) : !this.isShown && this.$backdrop ? (this.$backdrop.removeClass("in"), i = function() {
      s.removeBackdrop(), e2 && e2();
    }, o.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", i).emulateTransitionEnd(a.BACKDROP_TRANSITION_DURATION) : i()) : e2 && e2();
  }, a.prototype.handleUpdate = function() {
    this.adjustDialog();
  }, a.prototype.adjustDialog = function() {
    var e2 = this.$element[0].scrollHeight > document.documentElement.clientHeight;
    this.$element.css({ paddingLeft: !this.bodyIsOverflowing && e2 ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !e2 ? this.scrollbarWidth : "" });
  }, a.prototype.resetAdjustments = function() {
    this.$element.css({ paddingLeft: "", paddingRight: "" });
  }, a.prototype.checkScrollbar = function() {
    var e2, t = window.innerWidth;
    t || (t = (e2 = document.documentElement.getBoundingClientRect()).right - Math.abs(e2.left)), this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar();
  }, a.prototype.setScrollbar = function() {
    var e2 = parseInt(this.$body.css("padding-right") || 0, 10);
    this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", e2 + this.scrollbarWidth);
  }, a.prototype.resetScrollbar = function() {
    this.$body.css("padding-right", this.originalBodyPad);
  }, a.prototype.measureScrollbar = function() {
    var e2 = document.createElement("div"), t = (e2.className = "modal-scrollbar-measure", this.$body.append(e2), e2.offsetWidth - e2.clientWidth);
    return this.$body[0].removeChild(e2), t;
  };
  var e = o.fn.modal;
  o.fn.modal = n, o.fn.modal.Constructor = a, o.fn.modal.noConflict = function() {
    return o.fn.modal = e, this;
  }, o(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e2) {
    var t = o(this), s = t.attr("href"), i = o(t.attr("data-target") || s && s.replace(/.*(?=#[^\s]+$)/, "")), s = i.data("bs.modal") ? "toggle" : o.extend({ remote: !/#/.test(s) && s }, i.data(), t.data());
    t.is("a") && e2.preventDefault(), i.one("show.bs.modal", function(e3) {
      e3.isDefaultPrevented() || i.one("hidden.bs.modal", function() {
        t.is(":visible") && t.trigger("focus");
      });
    }), n.call(i, s, this);
  });
})(jQuery), (function(a) {
  "use strict";
  var l = function(e2) {
    this.element = a(e2);
  };
  function t(s2) {
    return this.each(function() {
      var e2 = a(this), t2 = e2.data("bs.tab");
      t2 || e2.data("bs.tab", t2 = new l(this)), "string" == typeof s2 && t2[s2]();
    });
  }
  l.VERSION = "3.3.7", l.TRANSITION_DURATION = 150, l.prototype.show = function() {
    var e2, t2, s2, i = this.element, n = i.closest("ul:not(.dropdown-menu)"), o = (o = i.data("target")) || (o = i.attr("href")) && o.replace(/.*(?=#[^\s]*$)/, "");
    i.parent("li").hasClass("active") || (e2 = n.find(".active:last a"), t2 = a.Event("hide.bs.tab", { relatedTarget: i[0] }), s2 = a.Event("show.bs.tab", { relatedTarget: e2[0] }), e2.trigger(t2), i.trigger(s2), s2.isDefaultPrevented()) || t2.isDefaultPrevented() || (s2 = a(o), this.activate(i.closest("li"), n), this.activate(s2, s2.parent(), function() {
      e2.trigger({ type: "hidden.bs.tab", relatedTarget: i[0] }), i.trigger({ type: "shown.bs.tab", relatedTarget: e2[0] });
    }));
  }, l.prototype.activate = function(e2, t2, s2) {
    var i = t2.find("> .active"), n = s2 && a.support.transition && (i.length && i.hasClass("fade") || !!t2.find("> .fade").length);
    function o() {
      i.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", false), e2.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", true), n ? (e2[0].offsetWidth, e2.addClass("in")) : e2.removeClass("fade"), e2.parent(".dropdown-menu").length && e2.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", true), s2 && s2();
    }
    i.length && n ? i.one("bsTransitionEnd", o).emulateTransitionEnd(l.TRANSITION_DURATION) : o(), i.removeClass("in");
  };
  var e = a.fn.tab, s = (a.fn.tab = t, a.fn.tab.Constructor = l, a.fn.tab.noConflict = function() {
    return a.fn.tab = e, this;
  }, function(e2) {
    e2.preventDefault(), t.call(a(this), "show");
  });
  a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', s).on("click.bs.tab.data-api", '[data-toggle="pill"]', s);
})(jQuery), (function(i) {
  "use strict";
  var n = function(e2, t) {
    this.options = i.extend({}, n.DEFAULTS, t), this.$target = i(this.options.target).on("scroll.bs.sticky.data-api", i.proxy(this.checkPosition, this)).on("click.bs.sticky.data-api", i.proxy(this.checkPositionWithEventLoop, this)).on("resize.bs.sticky.data-api", i.proxy(this.onResize, this)), this.$element = i(e2), this.pin = null, this.initialPosition = this.$element.offset(), this.initialWidth = this.$element.outerWidth(), this.initialHeight = this.$element.outerHeight(), this.$clone = null, this.maxTopPosition = null, this.$parent = this.getParent(t.parent), this.getParentBottomBound(), this.checkPosition();
  };
  function s(s2) {
    return this.each(function() {
      var e2 = i(this), t = e2.data("bs.sticky");
      t || e2.data("bs.sticky", t = new n(this, "object" == typeof s2 && s2)), "string" == typeof s2 && t[s2]();
    });
  }
  n.VERSION = "1.0.0", n.DEFAULTS = { target: window }, n.prototype.getParent = function(e2) {
    e2 = e2 && this.$element.closest(e2) ? this.$element.closest(e2) : this.$element.parent();
    return e2;
  }, n.prototype.getParentBottomBound = function() {
    var e2 = this.$parent.offset().top, t = this.$parent.height();
    this.maxTopPosition = e2 + t;
  }, n.prototype.checkPositionWithEventLoop = function() {
    setTimeout(i.proxy(this.checkPosition, this), 1);
  }, n.prototype.onResize = function() {
    this.initialPosition = this.$element.offset(), this.initialWidth = this.$element.outerWidth(), this.initialHeight = this.$element.outerHeight(), this.getParentBottomBound(), this.checkPosition();
  }, n.prototype.checkPosition = function() {
    var e2;
    this.$element.is(":visible") && (e2 = this.$target.scrollTop(), this.$element.offset(), this.initialPosition.top - parseInt(this.$element.css("marginTop"), 10) > e2 ? (this.$clone && (this.$clone.remove(), this.$clone = null, this.$element.trigger("unpinned.bs.sticky")), this.$element.css({ visibility: "visible" }), this.pin = false) : (e2 + this.initialHeight < this.maxTopPosition ? this.$clone && this.$clone.css({ position: "fixed", top: 0 }) : this.$clone && this.$clone.css({ position: "absolute", top: this.maxTopPosition - this.initialHeight }), this.$clone || (this.$clone = this.$element.clone(true, true).appendTo("body"), this.$element.css({ visibility: "hidden" }).trigger("pinned.bs.sticky")), this.$clone.removeClass("unpinned").addClass("pinned").css({ width: this.initialWidth, left: this.initialPosition.left }), this.pin = true));
  };
  var e = i.fn.sticky;
  i.fn.sticky = s, i.fn.sticky.Constructor = n, i.fn.sticky.noConflict = function() {
    return i.fn.sticky = e, this;
  }, i(window).on("load", function() {
    i('[data-position="sticky"]').each(function() {
      var e2 = i(this), t = e2.data();
      s.call(e2, t);
    });
  });
})(jQuery);
;
!(function() {
  function c() {
    var e = document.getElementById("dropdown-menu-account"), t = document.getElementById("trigger-dropdown-account");
    if (!e || !t) return;
    e.setAttribute("hidden", "");
    e.setAttribute("aria-hidden", "true");
    e.classList.remove("is-open");
    t.setAttribute("aria-expanded", "false");
  }
  function u(e) {
    var t = document.getElementById("dropdown-menu-account"), n = document.getElementById("trigger-dropdown-account");
    if (!t || !n) return e && e.preventDefault(), false;
    var i = t.classList.contains("is-open");
    i ? c() : (t.removeAttribute("hidden"), t.setAttribute("aria-hidden", "false"), t.classList.add("is-open"), n.setAttribute("aria-expanded", "true"), t.focus()), e && e.preventDefault();
    return false;
  }
  function d(e) {
    var t = document.getElementById("dropdown-menu-account"), n = document.getElementById("trigger-dropdown-account");
    if (!t || !n) return;
    t.classList.contains("is-open") && (t.contains(e.target) || n.contains(e.target) || c());
  }
  function s(e) {
    e && e.stopImmediatePropagation ? e.stopImmediatePropagation() : e && e.stopPropagation && e.stopPropagation(), e && e.preventDefault && e.preventDefault();
  }
  document.addEventListener("click", function(e) {
    if (e.target.closest("#trigger-dropdown-account")) return s(e), u(e);
  }, true), document.addEventListener("keydown", function(e) {
    ("Escape" === e.key || 27 === e.keyCode) && c();
  }), document.addEventListener("pointerdown", d, true), document.addEventListener("click", d, true);
})();
!/* @__PURE__ */ (function() {
})();
